import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Member from './Member';
import NewMember from './NewMember';

class MembersList extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    const { status, team } = nextProps;

    if (this.props.status !== status) {
      if (
        status === actionTypes.MEMBER_UPDATE_SUCCESS ||
        status === actionTypes.MEMBER_CREATE_SUCCESS ||
        status === actionTypes.MEMBER_DELETE_SUCCESS
      ) {
        this.props.loadMembers(team.id);
      }

      if (status === actionTypes.MEMBER_DELETE_ERROR) {
        this.props.hideAlert();
        this.props.alert(
          'error',
          'This collaborator is already included on an agreement and cannnot be deleted. To create a new agreement without this collaborator, please create a new team.'
        );
      }
    }
  }

  getMembers() {
    const { members } = this.props;

    if (members) {
      return members.map((member, i) => (
        <Member key={i} member={member} type={this.props.type} />
      ));
    }
  }

  render() {
    return (
      <div className="members">
        <h5 className="uppercase">Collaborators on this team</h5>
        {this.getMembers()}
        <NewMember type={this.props.type} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  members: state.users.members,
  status: state.users.status,
  team: state.teams.selectedTeam,
});

const mapDispatchToProps = (dispatch) => ({
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MembersList);



// WEBPACK FOOTER //
// src/components/Members/MembersList.jsx